import * as React from "react";
export const AsideMenu = ({ children, topItems, bottomItems, }) => (React.createElement("aside", { className: "fixed inset-y-0 left-0 z-[101] hidden lg:flex flex-row border-r bg-skvedarkblue-950 app-nav" },
    React.createElement("div", { className: "w-14 flex flex-col flex-1 h-full" },
        React.createElement("nav", { className: "flex flex-col items-center gap-4 px-2 lg:py-5" }, topItems),
        React.createElement("nav", { className: "mt-auto flex flex-col items-center gap-4 px-2 lg:py-5" }, bottomItems)),
    children));
//# sourceMappingURL=AsideMenu.js.map